import {
  STOCK_DELETE_STOCK_BEGIN,
  STOCK_DELETE_STOCK_SUCCESS,
  STOCK_DELETE_STOCK_FAILURE,
  STOCK_DELETE_STOCK_DISMISS_ERROR,
  STOCK_DELETE_STOCK_SUCCESS_EFFECT,
} from './constants';
import axios from 'axios';
import { STOCKS_ENDPOINT } from 'cfgCommon/endpoints'

export function deleteStock({ idStock }) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: STOCK_DELETE_STOCK_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {

      const doRequest = axios.delete(STOCKS_ENDPOINT + `/${idStock}`)

      doRequest.then(
        (res) => {
          setTimeout(() => {
            dispatch({
              type: STOCK_DELETE_STOCK_SUCCESS_EFFECT,
              data: { id: idStock }
            })
          }, 500)

          dispatch({
            type: STOCK_DELETE_STOCK_SUCCESS,
            data: { id: idStock },
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          if(err?.response?.status === 403) err.message = err.response.data.message;
          dispatch({
            type: STOCK_DELETE_STOCK_FAILURE,
            data: { error: err.response?.data?.message? err.response.data.message : "Error al eliminar stock" },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissDeleteStockError() {
  return {
    type: STOCK_DELETE_STOCK_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case STOCK_DELETE_STOCK_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        deleteStockPending: true,
        deleteStockError: null,
      };

    case STOCK_DELETE_STOCK_SUCCESS:
      // The request is success
      return {
        ...state,
        deletedStockId: action.data.id,
        deleteStockPending: false,
        deleteStockError: null,
      };
    case STOCK_DELETE_STOCK_SUCCESS_EFFECT:
      // The request is success
      return {
        ...state,
        //Quito el stock eliminado
        stocksProductoData: state.stocksProductoData.filter(({id})=>id !== action.data.id),
        deletedStockId: undefined,
      };
    case STOCK_DELETE_STOCK_FAILURE:
      // The request is failed
      return {
        ...state,
        deleteStockPending: false,
        deleteStockError: action.data.error,
      };

    case STOCK_DELETE_STOCK_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        deleteStockError: null,
      };

    default:
      return state;
  }
}
